import { z } from 'zod'
import { Model } from './architecture'

export const PostalCodeValidation = z.object({
  value: z.string({ required_error: '[PostalCode] value is required' }),
})

export class PostalCode extends Model {
  static create({ value }: z.infer<typeof PostalCodeValidation>) {
    PostalCodeValidation.parse({ value })
    return new PostalCode(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  getPostalCode() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.getPostalCode() }
  }
}
